module.exports = __webpack_public_path__ + "static/media/profile-img.82077927.jpeg";